import React from 'react';
import { connect } from 'react-redux';
import __isEmpty from 'lodash/isEmpty';
import __toLower from 'lodash/toLower';
import __forEach from 'lodash/forEach';
import __startsWith from 'lodash/startsWith';

import { getUserByEmail } from '../../../services/parse';
import { notify } from '../../../services/functions';
import { saveEmail, savePromoCoupon } from '../../../redux/actions';
import { sendAnalyticsEvent } from '../../../services/analytics';
import { getPageUrl } from '../../../utils/locationUtils';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import PasswordInput from '../../../components/forms/inputs/PasswordInput';

const queryString = require('query-string');

class RegisterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasAccount: false,
      userFromEmail: {},
      email: '',
      confirmedEmail: '',
      password: '',
      confirmedPassword: '',
      promoCode: '',
      errorEmail: '',
      errorConfirmEmail: '',
      errorPassword: '',
      errorConfirmPassword: '',
      errorPromoCode: '',
      offersSignup: true,
      validForm: false,
    };
  }

  componentDidMount() {
    const parsedQuery = !__isEmpty(this.props.location.search) ? queryString.parse(this.props.location.search) : null;

    if (parsedQuery && parsedQuery.email) {
      // check if email already exists and if so reroute to the login promo form
      getUserByEmail(parsedQuery.email).then((results) => {
        if (!__isEmpty(results)) {
          this.setState({ hasAccount: true });
          this.setState({ userFromEmail: results });
        }
      }).catch((error) => {
        console.log(error);
      });
      this.setState({ email: parsedQuery.email });
      this.props.saveEmail(parsedQuery.email);
    }

    let codeType = null;
    if (parsedQuery && parsedQuery.promoCode) {
      // promotional codes for a web offer, like 1mfoofree
      codeType = parsedQuery.promoCode.toLowerCase();
    } else if (parsedQuery && parsedQuery.couponCode) {
      // coupon codes, like CS000-0000-00000 etc
      codeType = parsedQuery.couponCode.toLowerCase();
    }

    if (codeType !== null) {
      this.setState({ promoCode: codeType.toUpperCase() });
      this.props.savePromoCoupon(codeType);
      this.props.setPromoCode(codeType);
    }

    sendAnalyticsEvent('web_onboarding_screen_login_setup', {
      'app': 'web-site',
      'page_URL': getPageUrl(window.location),
    }, true);

    document.getElementById('promo-email').scrollIntoView({ behavior: 'smooth' });
    if (document.getElementById('promo-email-loggedIn')) {
      document.getElementById('promo-email-loggedIn').scrollIntoView({ behavior: 'smooth' });
    }

    this.onPasswordBlur = this.onPasswordBlur.bind(this);
    this.submitPasswordForLoginWithEvent = this.submitPasswordForLoginWithEvent.bind(this);
  }

  setHasAccount = (value) => {
    this.setState({ hasAccount: value });
  }

  setEmailForLogin = e => {
    this.setState({ email: e.target.value });
    this.props.setEmail(e.target.value)
  }

  setConfirmedEmail = e => {
    this.setState({ confirmedEmail: e.target.value });
  }

  submitPasswordForLogin = ({ password, validPassword }) => {
    this.setState({ password, validForm: validPassword });
    this.props.setPasswordToSubmit(password);
  }

  submitPasswordForLoginWithEvent(e) {
    const password = e.target.value;
    this.submitPasswordForLogin({ password });
  }

  onPasswordBlur() {
    this.checkConfirmPassword();
  }

  setConfirmedPassword = e => {
    this.setState({ confirmedPassword: e.target.value });
  }

  setPromoCode = e => {
    this.setState({ promoCode: e.target.value });
  }

  sendPromoCode = e => {
    this.props.setPromoCode(e.target.value);
  }

  setAndSendPromoCode = () => {
    this.props.setPromoCode(this.state.promoCode);
  }

  handleEmailSignup = (e) => {
    this.setState({ [e.target.name]: e.target.checked });

    this.props.handleCheckChange(e);
  }

  updateCaptcha = (value)=>{
    this.props.updateCaptcha(value);
  }
  checkEmail = (e) => {
    const { email, confirmedEmail } = this.state;
    const submittedEmail = e.target.value;
    const field = e.target.name;

    if (email !== confirmedEmail) {
      this.showEmailErrors('Email address does not match confirm');
      return;
    }

    //make sure it's a valid email address with regex
    let emailExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!__isEmpty(submittedEmail) && !emailExp.test(__toLower(submittedEmail))) {
      if (field === 'email') {
        this.showEmailErrors('Please enter a valid email address');
        return;
      } else {
        this.showConfirmEmailErrors('Please enter a valid email address');
        return;
      }
    }
    //test for any captial letters
    let captialLetter = /^[A-Z]*$/;
    if (!__isEmpty(submittedEmail) && submittedEmail.match(captialLetter) !== null) {
      if (field === 'email') {
        this.showEmailErrors('Please do not use capital letters');
        return;
      } else {
        this.showConfirmEmailErrors('Please do not use capital letters');
        return;
      }
    }

    if (e.target.name === 'confirm-email' && submittedEmail !== email) {
      document.getElementById("promo-email").classList.add('has-error');
      this.showConfirmEmailErrors('Emails do not match');
      return;
    }

    //if the user has an account, prompt them to log in
    if ((!__isEmpty(confirmedEmail) && !__isEmpty(email)) && confirmedEmail === email) {
      // this scenario is for those who ignore the login reroute and choose to try and register again
      if (!__isEmpty(this.state.userFromEmail)) {
        notify('error', 'It looks like you have an account. Click here to log in.', 5000, () => {
          this.setState({ hasAccount: true });
        });
      } else {
        getUserByEmail(email).then((results) => {
          //don't show duplicate errors for login message
          let showLoginNote = true;
          let notifications = document.getElementsByClassName('message');

          __forEach(notifications, (message) => {
            if (__startsWith(message.textContent, 'It looks like you have an account')) {
              showLoginNote = false;
              return false;
            }
          });
          if (!__isEmpty(results) && showLoginNote) {
            //we have a user, so make a persistent notification show
            notify('error', 'It looks like you have an account. Click here to log in.', 5000, () => {
              // setHasAccount(true);
              this.setState({ hasAccount: true });
            });
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    }
    this.removeEmailErrors();
  }

  checkConfirmPassword = () => {
    const { password, confirmedPassword } = this.state;

    if ((!__isEmpty(password) && !__isEmpty(confirmedPassword)) && confirmedPassword !== password) {
      this.showConfirmPasswordErrors('Passwords do not match');
      return;
    }

    // send the confirmed password back to parent component
    if (!__isEmpty(confirmedPassword)) {
      this.props.setConfirmedPassword(confirmedPassword);
    }
    this.removePasswordErrors();
  }

  showEmailErrors = (message) => {
    document.getElementById("promo-email").classList.add('has-error');
    document.getElementById("promo-email-error").classList.remove('hide-error');
    this.setState({ errorEmail: message });
  }

  showConfirmEmailErrors = (message) => {
    document.getElementById("promo-confirm-email").classList.add('has-error');
    document.getElementById("promo-confirm-email-error").classList.remove('hide-error');
    this.setState({ errorConfirmEmail: message });
  }

  removeEmailErrors = () => {
    document.getElementById("promo-email").classList.remove('has-error');
    document.getElementById("promo-email-error").classList.add('hide-error');
    document.getElementById("promo-confirm-email").classList.remove('has-error');
    document.getElementById("promo-confirm-email-error").classList.add('hide-error');
  }

  showConfirmPasswordErrors = (message) => {
    document.getElementById("promo-confirm-password").classList.add('has-error');
    document.getElementById("promo-confirm-password-error").classList.remove('hide-error');
    this.setState({ errorConfirmPassword: message });
  }

  removePasswordErrors = () => {
    document.getElementById("promo-confirm-password").classList.remove('has-error');
    document.getElementById("promo-confirm-password-error").classList.add('hide-error');
  }

  submitForm = async (e) => {
    e.preventDefault();
    // reCaptcha v3
    const { executeRecaptcha } = (this.props).googleReCaptchaProps;
    const captchaToken = await executeRecaptcha('promoRegistration');
    this.updateCaptcha(captchaToken);
    this.props.registerForm(this.state.validForm);
  }

  render() {
    const { hasAccount, email, confirmedEmail, password, confirmedPassword, promoCode } = this.state;

    if (hasAccount) {
      return (
        <div className="login-form-wrapper" >
          <h2 className="create-header text-center">Log in and save!</h2>
          <p className="login-link text-center">Don’t have an account yet? <button className="login-link" onClick={() => this.setHasAccount(false)}>Register</button></p>
          <div className="registration-form">
            <div className="input-fields">
              <label>Your Email</label>
              <div className="textbox">
                <input
                  type="text"
                  id="promo-email-loggedIn"
                  name="email"
                  onChange={this.setEmailForLogin}
                  value={email}
                  autoFocus
                />
              </div>
            </div>
            <div className="input-fields">
              <label>Your Password</label>
              <div className="textbox">
                <input
                  type="password"
                  name="password"
                  value={password}
                  onChange={this.submitPasswordForLoginWithEvent}
                />
              </div>
              <div className='reset-password' >
                <a href="/request-password-reset" target="_blank">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div className="input-fields">
              <label>Promo Code</label>
              <div className="textbox">
                <input
                  type="text"
                  name="promo-code"
                  id="promo-code-register"
                  onChange={this.setPromoCode}
                  value={promoCode}
                />
                <i id="code-field" className="fa fa-check-circle" aria-hidden="true"></i>
                <p id="promo-code-error" className="error-message right hide-error">Promo code not valid</p>
              </div>
            </div>
          </div>
          {
            this.props.isValidCode ? (
              <div className="cta-button large" onClick={this.props.loginForm}>
                <button
                  data-event-category="button"
                  data-event-action="promo-redemeption-login"
                  data-event-label="Log Into Account"
                  data-on="Click"
                >
                  Redeem Offer
                </button>
              </div>
            ) : (
              <div className="cta-button large" onClick={this.setAndSendPromoCode}>
                <button
                  data-event-category="button"
                  data-event-action="promo-redemption-logged-in"
                  data-event-label="Already Logged In Redeeming Promo"
                  data-on="Click"
                >
                  Validate code
                </button>
              </div>
            )
          }
        </div>
      )
    } else {
      return (
        <div>
          <h2 className="create-header text-center">Create your account and save!</h2>
          <p className="login-link text-center">Already have an account? <button className="login-link" onClick={() => this.setHasAccount(true)}>Log In</button></p>
          <div className="registration-form">
            <div className="input-fields">
              <label>Your Email</label>
              <div className="textbox">
                <input
                  type="text"
                  name="email"
                  id="promo-email"
                  onChange={this.setEmailForLogin}
                  onBlur={this.checkEmail}
                  value={email}
                  autoFocus
                />
                <p id="promo-email-error" className="error-message right hide-error">{this.state.errorEmail}</p>
              </div>
            </div>
            <div className="input-fields">
              <label>Confirm Your Email</label>
              <div className="textbox">
                <input
                  type="text"
                  name="confirm-email"
                  id="promo-confirm-email"
                  onChange={this.setConfirmedEmail}
                  onBlur={this.checkEmail}
                  value={confirmedEmail}
                />
                <p id="promo-confirm-email-error" className="error-message right hide-error">{this.state.errorConfirmEmail}</p>
              </div>
            </div>
            <div className="input-fields">
              <label>Choose a Password</label>
              <div className="textbox">
                <PasswordInput
                  id="promo-password"
                  value={password}
                  onChange={this.submitPasswordForLogin}
                  onBlur={this.onPasswordBlur}
                />
              </div>
            </div>
            <div className="input-fields">
              <label>Confirm Your Password</label>
              <div className="textbox">
                <input
                  type="password"
                  name="confirm-password"
                  id="promo-confirm-password"
                  autoComplete="on"
                  onChange={this.setConfirmedPassword}
                  onBlur={this.checkConfirmPassword}
                  value={confirmedPassword}
                />
                <p id="promo-confirm-password-error" className="error-message hide-error">{this.state.errorConfirmPassword}</p>
              </div>
            </div>
            <div className="input-fields">
              <label>Promo Code</label>
              <div className="textbox">
                <input
                  type="text"
                  name="promo-code"
                  id="promo-code-register"
                  onChange={this.setPromoCode}
                  onBlur={this.sendPromoCode}
                  value={promoCode}
                />
                <i id="code-field" className="fa fa-check-circle" aria-hidden="true"></i>
                <p id="promo-code-error" className="error-message right hide-error">Promo code not valid</p>
              </div>
            </div>
            <div className="checkbox-wrapper">
              <input name="offersSignup" type="checkbox" onChange={this.handleEmailSignup} checked={this.state.offersSignup} />
              <span>Yes! Please send me exclusive offers and updates on new app features.</span>
            </div>
            <div className="checkbox-wrapper">
              <input name="confirmTerms" type="checkbox" onChange={this.props.handleCheckChange} />
              <span>I have read and agree to the<a target="_blank" href={`${process.env.REACT_APP_CODESPARK_BASE_URL}/terms`} rel="noopener noreferrer"> Terms of Service </a>and<a target="_blank" href={`${process.env.REACT_APP_CODESPARK_BASE_URL}/privacy`} rel="noopener noreferrer"> Privacy Policy</a>.</span>
            </div>
          </div>
          <div className="cta-button-promo large" onClick={(e) => this.submitForm(e)}>
            <button
              data-event-category="button"
              data-event-action="promo-redemption-register-user"
              data-event-label="Create Account"
              data-on="Click"
            >
              Redeem Offer
            </button>
          </div>
        </div>
      )
    }
  }
}

const mapDispatchToProps = {
  saveEmail,
  savePromoCoupon
}

export const WithGoogleRecaptchaPromoRegForm = withGoogleReCaptcha(RegisterForm);
export default connect(null, mapDispatchToProps)(WithGoogleRecaptchaPromoRegForm);
